<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Produksi Detail # PR{{ produksiDetail.detail.id_produksi }}  </h1>
                <div class="section-header-breadcumb button">
                    <button v-if="produksiDetail.detail.is_delete_produksi == 0" class="btn btn-outline-danger" style="margin-right:5px" @click="deleteProduksi()"> <i class="fa fa-trash"></i> Unproduce</button>
                    <button v-else class="btn btn-danger" style="margin-right:5px"> <i class="fa fa-trash"></i> TELAH DI UNPRODUCE</button>
                </div>
            </div>
            <div class="section-body">
                <h2 class="section-title">Nama Produk : {{ produksiDetail.detail.nama_produk }} </h2>
                <p class="section-lead">Tanggal Produksi : {{ produksiDetail.detail.tanggal_produksi | moment("DD MMMM YYYY") }}  </p>
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="card">
                            <div class="card-header">
                                <h4>Informasi Produk</h4>
                            </div>
                            <div class="card-body">
                                <table class="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%;">
                                                Nama Produk
                                            </th>
                                            <td>
                                                {{ produksiDetail.detail.nama_produk }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Kode Produk  
                                            </th>
                                            <td>
                                                {{ produksiDetail.detail.kode_produk }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Qty Produksi 
                                            </th>
                                            <td>
                                                {{ parseFloat(produksiDetail.detail.qty_produksi) }} {{ produksiDetail.detail.nama_satuan }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="card">
                            <div class="card-header">
                                <h4>Bahan Produksi</h4>
                            </div>
                            <div class="card-body">
                                <table class="table table-striped">
                                    <tbody>
                                        <tr>
                                            <th>
                                                Nama Produk
                                            </th>
                                            <th>
                                                Kode Produk  
                                            </th>
                                            <th>
                                                Qty Digunakan 
                                            </th>
                                        </tr>
                                        <tr v-for="data in produksiDetail.bahanList" v-bind:key="data.id_produk">
                                            <td>
                                                {{ data.nama_produk }}
                                            </td>
                                            <td>
                                                {{ data.kode_produk }}
                                            </td>
                                            <td>
                                                {{ parseFloat(data.qty) }} {{ data.nama_satuan }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <button @click="goBack()" class="btn btn-danger">Kembali</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
    data() {
        return {
            produksiDetail : {
                detail : {
                    id_produksi : '',
                }
            },
            id_produksi : ''
        }
    },
    mounted() {
        this.id_produksi = this.$route.params.id_produksi
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.post("Produk/getProduksiDetail/"+this.id_produksi).then(result => {
                if(result.data.code == '00') {
                    alert('failed get Detail')
                    this.$root.is_loading = !this.$root.is_loading;
                }
                else {
                    this.produksiDetail = result.data.detail
                    this.$root.is_loading = !this.$root.is_loading;
                }
            }, error => {
                this.$root.is_loading = !this.$root.is_loading;
                console.log('gk ok')
                context.errors = errors;
            });
        },
        deleteProduksi: function() {
            if(!confirm('Apakah kamu yakin?')) {
                return false;
            }
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.post("Produk/deleteProduksi/"+this.id_produksi).then(result => {
                if(result.data.code == '00') {
                    alert('failed delete produksi')
                    this.$root.is_loading = !this.$root.is_loading;
                }
                else {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Produksi Berhasil Dihapus, qty bahan dan produk telah dikembalikan',
                        type : 'success'
                    }
                    this.$root.is_loading = !this.$root.is_loading;
                    this.goBack();
                }
            }, error => {
                this.$root.is_loading = !this.$root.is_loading;
                console.log('gk ok')
                context.errors = errors;
            });
        },
        goBack: function() { 
            this.$router.replace({ path : window.localStorage.getItem('last_route') })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/produksi/ProduksiDetail.vue